import { ComboItem, Response } from "../../../../model";
import { GatewayOut } from "../../../../model/cobranza";
import ServiceBase from "../../../servicebase";

export default class GatewayService extends ServiceBase {
  
  get = (data: { id?: number }) => 
    this.GetFetch<Response<GatewayOut>>('entity/gateway', data);

  combo = (data: { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<Response<ComboItem[]>>('entity/gateway/combo', data);
}
